
import React from 'react';
import { pdf } from "@react-pdf/renderer";
import { supabase } from "@/integrations/supabase/client";
import { InvoicePDF, type InvoiceData } from "../InvoicePDF";
import { FormData } from "../types";
import { toast } from "sonner";

export const createAndUploadPDF = async (values: FormData, user: any) => {
  try {
    
    // Fetch business profile to get logo URL
    const { data: profileData } = await supabase
      .from('business_profiles')
      .select('logo_url')
      .eq('user_id', user.id)
      .single();

    const subtotal = values.lineItems.reduce((total, item) => {
      return total + (item.quantity * item.unitPrice);
    }, 0);

    const taxes = values.taxes?.map(tax => ({
      name: tax.name || "IVA",
      percentage: tax.percentage || 23
    })) || [{ name: "IVA", percentage: 23 }];

    const pdfData: InvoiceData = {
      invoiceNumber: values.invoiceNumber,
      issueDate: values.issueDate,
      dueDate: values.dueDate,
      businessName: values.businessName,
      businessTaxId: values.businessTaxId,
      businessIban: values.businessIban,
      businessSwift: values.businessSwift,
      businessEmail: values.businessEmail,
      businessPhone: values.businessPhone,
      recipientName: values.recipientName,
      recipientEmail: values.recipientEmail,
      recipientAddress: values.recipientAddress,
      clientTaxId: values.clientTaxId,
      clientPhone: values.clientPhone,
      description: values.lineItems[0].description,
      quantity: values.lineItems[0].quantity,
      unitPrice: values.lineItems[0].unitPrice,
      bankAccountHolder: values.bankAccountHolder,
      bankIban: values.bankIban,
      bankName: values.bankName,
      bankSwift: values.bankSwift,
      paymentReference: values.paymentReference,
      taxes: taxes,
      logoUrl: profileData?.logo_url || undefined, // Add logo URL if available
    };

    const doc = await pdf(<InvoicePDF data={pdfData} />);
    
    const pdfBlob = await doc.toBlob();
    
    const fileName = `invoice_${values.invoiceNumber}.pdf`;

    const { data: fileData, error: uploadError } = await supabase.storage
      .from("invoices")
      .upload(`${user.id}/${fileName}`, pdfBlob, {
        contentType: "application/pdf",
        upsert: true,
      });

    if (uploadError) {
      console.error('Upload error:', uploadError);
      throw new Error(uploadError.message);
    }

    const { data: publicUrlData } = supabase.storage
      .from("invoices")
      .getPublicUrl(`${user.id}/${fileName}`);

    return {
      fileName,
      publicUrl: publicUrlData.publicUrl,
      subtotal,
    };
  } catch (error: any) {
    console.error('Error generating PDF:', error);
    throw new Error('Failed to generate PDF. Please try again.');
  }
};
